/**
 * Client manifest holding environment variable mapping and defaults
 * Defaults are for development environment to prevent exposure and easier localhost development
 *
 * IMPORTANT Any zwInit values in this file need to also be in ./scripts/appendEnvVarToIndex.js
 */

export const ENV = {
  ...process.env.BUILD_ENV,
  ...window.ENV
};

export const {
  NAME,
  DEPLOY_ENV,
  ROUTES,
  IS_PROD,
  IS_DEV,
  RELEASE_VERSION,
  DEFAULT_ROUTE,
  GRAPHQL_URL,
  DEFAULT_SEGMENT,
  USE_STRICTMODE,
  REQUIRE_MFA,
  TRACING
} = ENV;

export const PLAID = {
  ENABLED: ENV.PLAID_ENABLED,
  URL: ENV.PLAID_URL,
  ENV: ENV.PLAID_ENV
};

export const GOOGLE_MAPS = {
  KEY: ENV.ZENBUSINESS_GOOGLE_MAPS_KEY
};

export const ANALYTICS = {
  rudderstack: {
    apiKey: ENV.RUDDERSTACK_API_KEY,
    url: ENV.RUDDERSTACK_URL
  }
};
